import { api } from 'api/axios';
import { useQuery } from '@tanstack/react-query';

import urls from 'engine/urls';

const getAuthenticatedUser = () => {
    return api.get(urls().GetAuthenticatedUser)
  };

export const useGetAuthenticatedUser = (options) =>
  useQuery({
    queryKey: ['AuthenticatedUser'],
    queryFn: () => getAuthenticatedUser(),
    ...options,
  });
